const TOWER_API_BASE_URL = process.env.REACT_APP_API_BASE_URL
const TOWER_API_DEPARTMENT = process.env.REACT_APP_API_DEPARTMENT
const TOWER_API_SUBSCRIPTION = process.env.REACT_APP_API_SUBSCRIPTION
const TOWER_API_CONTACT = process.env.REACT_APP_API_CONTACT
const TOWER_API_USER = process.env.REACT_APP_API_USER

async function callApi(origin, endpoint, options = {}) {
    options.headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...options.headers,
    }

    const url = origin + endpoint
    const response = await fetch(url, options)

    if (!response.ok) {
        const error = new Error(response.statusText)
        error.response = response

        throw error
    } else {
        const data = await response.json()

        return data
    }
}
/*
  FAKE API
 Simulamos una API que trae informacion de los ITINERARIOS desde el S3 
*/
const FAKE_API_URL = 'https://desarrollo.towertravel.com.ar/multimedia/incoming'

async function callFakeApi(endpoint, options = {}) {
    options.headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    }
    const url = FAKE_API_URL + endpoint
    const response = await fetch(url, options)
    const data = await response.json()
    return data
}

const api = {
    contact: {
        default({ name, email, issue, message, language }) {
            return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_CONTACT}`, '', {
                method: 'POST',
                headers: {
                    'Accept-Language': language,
                },
                body: JSON.stringify({
                    nameLastname: name,
                    email,
                    subject: issue,
                    comment: message,
                    department: TOWER_API_DEPARTMENT,
                }),
            })
        },
        itinerary({
            name,
            email,
            phone,
            issue,
            message,
            nameItinerary,
            idItinerary,
            isSubcritedNewLetter,
            sendEmailCopy,
            language,
        }) {
            return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_CONTACT}`, '/itinerary', {
                method: 'POST',
                headers: {
                    'Accept-Language': language,
                },
                body: JSON.stringify({
                    nameLastname: name,
                    email,
                    subject: issue,
                    message: message,
                    department: TOWER_API_DEPARTMENT,
                    phone: phone,
                    nameItinerary,
                    idItinerary,
                    isSubcritedNewLetter,
                    sendEmailCopy,
                }),
            })
        },
        mice({ companyName, name, country, city, email, phone, quantity, message, language }) {
            console.log({ companyName, name, country, city, email, phone, quantity, message, language })

            return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_CONTACT}`, '/micegroups', {
                method: 'POST',
                headers: {
                    'Accept-Language': language,
                },
                body: JSON.stringify({
                    nameCompany: companyName,
                    nameLastname: name,
                    countryResidence: country,
                    city,
                    email,
                    phone,
                    adultQuantity: quantity,
                    message,
                    department: TOWER_API_DEPARTMENT,
                }),
            })
        },
        subscription({ email, language }) {
            return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_SUBSCRIPTION}`, '', {
                method: 'POST',
                headers: {
                    'Accept-Language': language,
                },
                body: JSON.stringify({
                    email,
                    department: TOWER_API_DEPARTMENT,
                }),
            })
        },
    },
    //Simulamos una API que trae informacion de los ITINERARIOS
    itineraries: {
        options(language) {
            return callFakeApi(`/itineraries-options-${language}.json`, { method: 'GET' })
        },
        async list(destination, type_of_experience, type_of_travel, language) {
            // console.log({ destination, type_of_experience, type_of_travel, language })

            const info = await callFakeApi(`/itineraries-reduced-info-${language}.json`, { method: 'GET' })

            //Ahora deberia filtrar la informacion de los ITINERARIOS para simular los filtros ACTUALES
            if (destination && type_of_experience && type_of_travel) {
                return info.filter(
                    (itinerary) =>
                        itinerary.destination.includes(destination) &&
                        itinerary.type_of_experience.includes(type_of_experience) &&
                        itinerary.type_of_travel.includes(type_of_travel)
                )
            } else if (destination && type_of_experience) {
                return info.filter(
                    (itinerary) =>
                        itinerary.destination.includes(destination) &&
                        itinerary.type_of_experience.includes(type_of_experience)
                )
            } else if (destination && type_of_travel) {
                return info.filter(
                    (itinerary) =>
                        itinerary.destination.includes(destination) && itinerary.type_of_travel.includes(type_of_travel)
                )
            } else if (type_of_experience && type_of_travel) {
                return info.filter(
                    (itinerary) =>
                        itinerary.type_of_experience.includes(type_of_experience) &&
                        itinerary.type_of_travel.includes(type_of_travel)
                )
            } else if (destination) {
                return info.filter((itinerary) => itinerary.destination.includes(destination))
            } else if (type_of_experience) {
                return info.filter((itinerary) => itinerary.type_of_experience.includes(type_of_experience))
            } else if (type_of_travel) {
                return info.filter((itinerary) => itinerary.type_of_travel.includes(type_of_travel))
            } else {
                return info
            }
        },
        async relateds(ids, language) {
            // ids va a ser un array de ids [1, 20, 45] serian los relacionados a un itinerario en especifico

            const info = await callFakeApi(`/itineraries-reduced-info-${language}.json`, { method: 'GET' })

            return info.filter((itinerary) => ids.includes(itinerary.id))
        },
        async single(slug, selectedItinerarieID, language) {
            const info = await callFakeApi(`/itineraries-${language}.json`, { method: 'GET' })

            //Si no lo encuentra por el nombre de la ruta, busca por el ID
            const itinerary =
                info.find((itinerary) => itinerary.slug === slug) ||
                info.find((itinerary) => itinerary.id === selectedItinerarieID)

            return itinerary
        },
    },
    //Destacados de la home
    destacados: {
        destacados(language) {
            return callFakeApi(`/destacados-home-${language}.json`, { method: 'GET' })
        },
    },
    whatsapp: {
        get({ language }) {
            return callApi(`${TOWER_API_BASE_URL}/${TOWER_API_USER}`, `/whatsapp/${TOWER_API_DEPARTMENT}`, {
                method: 'GET',
                headers: {
                    'Accept-Language': language,
                },
            })
        },
    },
}

export default api

// export const getSingleItinerary = async (lang, id) => {
//     const info = await fetch(`http://localhost:3005/itineraries-${lang}/${id}`)
//     const data = await info.json()

//     return data
// }
